











































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
   components: {
    Header,
    Menu,
    NextPrevBtn,
    Footer,
   }
})
export default class LetterArguments extends Vue {
  protected nxtprevLetterArguments =
  {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail3.png",
    NextImage: " ",
    PrevLink: "/Lettre_de_Motivation/Analyse",
    NextLink: " ",
  };
}
